import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';


export default class CCManagement {

  #rmp;
  #readingCaptionsFromHls = false;
  #defaultTextTrackIndex = 0;
  #ccFilesReady = false;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get ccFilesReady() {
    return this.#ccFilesReady;
  }

  get defaultTextTrackIndex() {
    return this.#defaultTextTrackIndex;
  }

  set defaultTextTrackIndex(value) {
    this.#defaultTextTrackIndex = value;
  }

  get readingCaptionsFromHls() {
    return this.#readingCaptionsFromHls;
  }

  set readingCaptionsFromHls(value) {
    this.#readingCaptionsFromHls = value;
  }

  #showTrackIos(index) {
    Logger.print('captions', 'show native track ' + index);
    const video = this.#rmp.dom.video;
    for (let i = 0, len = video.textTracks.length; i < len; i++) {
      if (i === index) {
        video.textTracks[i].mode = 'showing';
      } else {
        video.textTracks[i].mode = 'disabled';
      }
    }
  }

  #showShakaTrack(index) {
    const shakaPlayer = this.#rmp.shakaPlayer;
    const textTracks = shakaPlayer.getTextTracks();
    if (index >= 0 && index <= textTracks.length - 1) {
      shakaPlayer.selectTextTrack(textTracks[index]);
      shakaPlayer.setTextTrackVisibility(true);
    }
  }

  #hlsShowCaptions(index) {
    this.#rmp.textTracks.forEach(textTrack => {
      textTrack.mode = 'hidden';
    });
    this.#rmp.textTracks[index].mode = 'showing';
  }

  #hideTracks() {
    if (this.#rmp.hasExternalCCFiles) {
      if (Env.isIos[0]) {
        for (let i = 0, len = this.#rmp.dom.video.textTracks.length; i < len; i++) {
          this.#rmp.dom.video.textTracks[i].mode = 'disabled';
        }
      } else if (this.#rmp.rmpVttJS) {
        this.#rmp.rmpVttJS.ccEnabled = false;
        this.#rmp.rmpVttJS.ccData = null;
        FW.hide(this.#rmp.dom.ccArea);

      }
    } else if (this.#rmp.readingShaka) {
      this.#rmp.shakaPlayer.setTextTrackVisibility(false);
    } else if (this.#readingCaptionsFromHls) {
      for (let i = 0, len = this.#rmp.textTracks.length; i < len; i++) {
        this.#rmp.textTracks[i].mode = 'hidden';
      }
    }
    // hide Google Cast Text Tracks
    if (this.#rmp.rmpGoogleCastText) {
      this.#rmp.rmpGoogleCastText.setCastTextTrack(-1);
    }
  }

  #createCCItem(id, lang, label, index) {
    const button = FW.createElement(
      'button',
      id + ' rmp-button rmp-overlay-level rmp-color-bg',
      label,
      this.#rmp.rtl,
      true
    );
    if (lang.length > 0) {
      button.setAttribute('lang', lang);
      this.#rmp.rmpAccessible.button(button, label, true);
    }
    if (index === this.#defaultTextTrackIndex) {
      Logger.print('captions', 'default setting on CC track ' + index + ' detected');
      button.classList.add('rmp-overlay-level-active');
      if (id !== 'captions-off' && ((index - 1) > -1)) {
        if (this.#rmp.hasExternalCCFiles) {
          if (Env.isIos[0]) {
            this.#rmp.one('playing', () => {
              this.#showTrackIos(index - 1);
            });
          } else if (this.#rmp.rmpVttJS) {
            this.#rmp.rmpVttJS.parse(this.#rmp.loadedCCFiles[index - 1].data);
          }
        } else if (this.#rmp.readingShaka) {
          this.#showShakaTrack(index - 1);
        } else if (this.#readingCaptionsFromHls) {
          this.#hlsShowCaptions(index - 1);
        }
        this.#rmp.dispatch('texttrackchanged');
      }
    }
    this.#rmp.dom.ccItems.push(button);
    const ccMenuItemInteraction = this.ccMenuItemInteraction.bind(this);
    FW.addEvents(['touchend', 'click'], button, ccMenuItemInteraction);
    return button;
  }

  ccMenuItemInteraction(event) {
    if (!this.#rmp.dom.captionsOverlayLevelsArea) {
      return;
    }
    let element = null;
    let lang = null;
    if (event && event.type && event.target) {
      FW.eventStopPrevent(event);
      if (event.target.tagName.toLowerCase() === 'span') {
        element = event.target.parentNode;
      } else {
        element = event.target;
      }
      lang = element.getAttribute('lang');
    } else if (typeof event === 'string' && event !== '') {
      // call for API showCaptions
      lang = event;
      element = this.#rmp.dom.captionsOverlayLevelsArea.querySelector('[lang="' + lang + '"]');
    }
    if (element === null || lang === null) {
      return;
    }
    this.#rmp.rmpUIManagement.showChrome();
    // Set all buttons to inactive
    const captionList = this.#rmp.dom.captionsOverlayLevelsArea.querySelectorAll('.rmp-overlay-level');
    if (captionList.length > 0) {
      for (let i = 0, len = captionList.length; i < len; i++) {
        captionList[i].classList.remove('rmp-overlay-level-active');
      }
    }
    for (let i = 0, len = this.#rmp.loadedCCFiles.length; i < len; i++) {
      // For the 'captions-off' button, the first condition will never match
      // so all captions will be turned off
      if (element.classList.contains('captions-off')) {
        this.#defaultTextTrackIndex = 0;
        element.classList.add('rmp-overlay-level-active');
        this.#hideTracks();
        this.#rmp.dispatch('texttrackchanged');
        break;
      }
      if (this.#rmp.loadedCCFiles[i].lng === lang) {
        this.#defaultTextTrackIndex = i + 1;
        element.classList.add('rmp-overlay-level-active');
        if (this.#rmp.hasExternalCCFiles) {
          if (Env.isIos[0]) {
            this.#showTrackIos(i);
          } else if (this.#rmp.rmpVttJS) {
            this.#rmp.rmpVttJS.parse(this.#rmp.loadedCCFiles[i].data);
          }
        } else if (this.#rmp.readingShaka) {
          this.#showShakaTrack(i);
        } else if (this.#readingCaptionsFromHls) {
          this.#hlsShowCaptions(i);
        }
        if (this.#rmp.rmpGoogleCastText) {
          this.#rmp.rmpGoogleCastText.setCastTextTrack(i);
        }
        this.#rmp.dispatch('texttrackchanged');
        break;
      }
    }
    this.#rmp.rmpModuleManagement.close('captions');
  }

  getCCData() {
    if (this.#rmp.hasExternalCCFiles) {
      if (this.#rmp.rmpVttJS) {
        return this.#rmp.rmpVttJS.ccData;
      } else if (this.#rmp.dom.video.textTracks.length > 0) {
        const typesPattern = /(captions|subtitles|subtitle|caption|text)/i;
        const tracks = this.#rmp.dom.video.textTracks;
        const validTextTracks = [];
        for (let i = 0, len = tracks.length; i < len; i++) {
          const track = tracks[i];
          if (track && track.kind && typesPattern.test(track)) {
            validTextTracks.push(track);
          }
        }
        return validTextTracks;
      }
    } else if (this.#rmp.textTracks.length > 0) {
      return this.#rmp.textTracks;
    }
    return [{}];
  }

  // following method applies to all kind of captions to append the captions UI
  // vtt.js or native (CEA/VTT/TTM with HLS or MPEG-DASH)
  appendUI() {
    Logger.print('captions', 'start appending captions UI');
    if (this.#rmp.hasExternalCCFiles) {
      if (!Env.isIos[0]) {
        // reorder from ajax call
        this.#rmp.loadedCCFiles.forEach((loadedCCFile, index) => {
          if (loadedCCFile.lng === '') {
            this.#rmp.loadedCCFiles.splice(index, 1);
          }
        });
        if (this.#rmp.loadedCCFiles.length < 1) {
          return;
        }
        this.#rmp.dom.ccArea = FW.createElement('div', 'rmp-cc-area');
        FW.hide(this.#rmp.dom.ccArea);
        FW.insertBefore(this.#rmp.dom.content, this.#rmp.dom.ccArea, this.#rmp.dom.video.nextSibling);
      }
      this.#ccFilesReady = true;
    }
    for (let i = 0, len = this.#rmp.loadedCCFiles.length; i < len; i++) {
      if (this.#rmp.loadedCCFiles[i].default) {
        this.#defaultTextTrackIndex = i + 1;
        break;
      }
    }
    // append CC module 
    this.#rmp.rmpModuleManagement.appendToControlBar('captions');
    this.#rmp.rmpModuleManagement.appendOverlay('captions');
    this.#rmp.dom.captionsOverlayLevelsArea.appendChild(
      this.#createCCItem('captions-off', 'off', this.#rmp.labels.hint.off, 0)
    );
    this.#rmp.loadedCCFiles.forEach((loadedCCFile, index) => {
      if (loadedCCFile) {
        const languageCode = loadedCCFile.lng;
        let label = loadedCCFile.name;
        if (this.#rmp.customTrackNames.captions.length > 0 && this.#rmp.customTrackNames.captions[index]) {
          label = this.#rmp.customTrackNames.captions[index];
        }
        this.#rmp.dom.captionsOverlayLevelsArea.appendChild(
          this.#createCCItem('captions-' + languageCode, languageCode, label, index + 1)
        );
      }
    });
    this.#rmp.dispatch('alltexttracksloaded');
  }

  destroy() {
    this.#hideTracks();
    this.#rmp.textTracks = [];
    this.#rmp.rmpModuleManagement.destroy('captions');
    if (this.#rmp.rmpVttJS) {
      this.#rmp.rmpVttJS.destroy();
    }
    this.#defaultTextTrackIndex = 0;
    this.#rmp.loadedCCFiles = [];
    this.#rmp.ccFiles = [];
    this.#rmp.hasExternalCCFiles = false;
  }

}
